import * as Sentry from '@sentry/react';

import { APP_BUILD_VERSION, DEVELOPMENT, SENTRY_DSN } from 'src/config-global';

Sentry.init({
  dsn: SENTRY_DSN,

  // Only send errors in production — no noise during development
  enabled: !DEVELOPMENT,

  // Correlate errors to specific deployments
  release: APP_BUILD_VERSION || 'unknown',

  // Percentage of transactions captured for performance monitoring (0.1 = 10%)
  tracesSampleRate: 0.1,

  // --- Optional configuration ---

  // Set environment name to distinguish errors from staging vs production
  // environment: import.meta.env.VITE_ENVIRONMENT || 'production',

  // Session Replay — records user sessions when an error occurs.
  // Useful for reproducing bugs by watching exactly what the user did.
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0.01,
  integrations: [Sentry.replayIntegration()],

  // Filter out specific errors that are not actionable
  beforeSend(event) {
    // Ignore chunk load errors (happen when user has stale cached JS after deployment)
    if (event.exception?.values?.[0]?.type === 'ChunkLoadError') return null;
    // Ignore network errors caused by user's connection issues
    if (event.exception?.values?.[0]?.value?.includes('Network Error')) return null;
    return event;
  },

  // Only send errors from your own domain, filtering out third-party script errors.
  // Uncomment and adjust the regex to match your production domain.
  // allowUrls: [/https:\/\/.*\.profy\.uz/],

  // Ignore common browser extension errors and non-actionable noise
  // denyUrls: [/extensions\//i, /^chrome:\/\//i, /^moz-extension:\/\//i],
});
